import {
  Modal,
  Table,
  Progress,
  Statistic,
  Row,
  Col,
  Alert,
  Skeleton,
} from 'antd';
import { useEffect, useReducer, useState } from 'react';
import { deleteDeliveryWithoutMessage } from '@DELIVERIES';

const initialState = [];
const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET_DELIVERIES':
      return payload.map((delivery) => ({
        ...delivery,
        status: 'RUNNING',
      }));
    case 'DELETE_DELIVERY_STATUS_SUCCESS':
      return state.map((delivery) => {
        if (delivery.id === payload.id) {
          return {
            ...delivery,
            status: 'SUCCESS',
          };
        }
        return delivery;
      });
    case 'DELETE_DELIVERY_STATUS_ERROR':
      return state.map((delivery) => {
        if (delivery.id === payload.id) {
          return {
            ...delivery,
            status: 'ERROR',
            errorMessage: payload.errorMessage,
          };
        }
        return delivery;
      });
    default:
      break;
  }
};

const DeleteResultModal = ({ onClose, data }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const [waitingCount, setWaitingCount] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sipariş numarası',
      dataIndex: 'customerDeliveryNo',
      key: 'customerDeliveryNo',
      width: '25%',
    },
    {
      title: 'Barkod',
      dataIndex: 'barcode',
      key: 'barcode',
      width: '25%',
    },
    {
      title: 'Durum',
      dataIndex: 'status',
      key: 'status',
      width: '50%',
      render: (data, record) => {
        switch (data) {
          case 'RUNNING':
            return <Skeleton.Input active block shape="round" size="small" />;
          case 'SUCCESS':
            return <Progress percent={100} size="small" />;
          case 'ERROR':
            return (
              <Alert message={record.errorMessage} type="error" showIcon />
            );
          default:
            return 'HATA!';
        }
      },
    },
  ];

  useEffect(() => {
    dispatch({ type: 'SET_DELIVERIES', payload: data });
  }, [data, dispatch]);

  useEffect(() => {
    if (state) {
      const success = state?.filter(
        (delivery) => delivery.status === 'SUCCESS'
      );
      const error = state?.filter((delivery) => delivery.status === 'ERROR');
      const waiting = state?.filter(
        (delivery) => delivery.status === 'RUNNING'
      );

      setSuccessCount(success.length);
      setErrorCount(error.length);
      setWaitingCount(waiting.length);
    }
  }, [data, state, dispatch]);

  const packageResolver = (item) => {
    return new Promise((resolve) => {
      deleteDeliveryWithoutMessage(item.id).then((result) => {
        if (result?.response?.status === 400) {
          resolve({
            success: false,
            message: result.response.data.message,
          });
        } else {
          resolve({ success: true });
        }
      });
    });
  };

  const packageDoNextPromise = (index) => {
    packageResolver(state[index]).then((result) => {
      if (result.success) {
        dispatch({
          type: 'DELETE_DELIVERY_STATUS_SUCCESS',
          payload: { id: state[index].id },
        });
      } else {
        dispatch({
          type: 'DELETE_DELIVERY_STATUS_ERROR',
          payload: { id: state[index].id, errorMessage: result.message },
        });
      }
      index++;
      if (index < state.length) {
        packageDoNextPromise(index);
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (state && state.length > 0 && !mounted) {
      packageDoNextPromise(0);
      setMounted(true);
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <Modal
      visible
      title="Toplu Gönderi Silme Durumu"
      onCancel={() => {
        if (!loading) {
          onClose();
        }
      }}
      width={950}
      footer={null}
    >
      <Row gutter={24}>
        <Col span={8}>
          <Statistic
            title="Başarıyla Silinen Gönderi Sayısı"
            value={successCount}
          />
        </Col>
        <Col span={8}>
          <Statistic title="Hatalı Gönderi Sayısı" value={errorCount} />
        </Col>
        <Col span={8}>
          <Statistic
            title="Sırada Bekleyen Gönderi Sayısı"
            value={waitingCount}
          />
        </Col>
      </Row>
      <div style={{ marginTop: 24 }}>
        <Table
          pagination={false}
          columns={columns}
          dataSource={state}
          scroll={{ y: 400 }}
          bordered
          rowKey="barcode"
        />
      </div>
    </Modal>
  );
};

export default DeleteResultModal;
